import React from 'react';
import { KeyRound, ArrowRight } from 'lucide-react';

const GroqKeyRequired = ({ onSetupClick }) => {
  return (
    <div style={{
      background: 'linear-gradient(to right, #fef2f2, #fff1f2)',
      border: '1px solid #fecaca',
      borderRadius: '12px',
      padding: '20px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '24px',
      boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.1)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{ background: '#fee2e2', padding: '12px', borderRadius: '50%' }}>
          <KeyRound size={24} color="#ef4444" />
        </div>
        <div>
          <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#991b1b', margin: '0 0 4px 0' }}>
            Groq API Key Required
          </h3>
          <p style={{ color: '#b91c1c', margin: 0, fontSize: '14px' }}>
            Set your Groq API key to enable AI auto-replies and smart conversation features.
          </p>
        </div>
      </div>
      <button 
        onClick={onSetupClick}
        style={{
          display: 'flex', alignItems: 'center', gap: '8px',
          background: '#ef4444', color: 'white', border: 'none',
          padding: '10px 20px', borderRadius: '8px', fontWeight: 'bold',
          cursor: 'pointer', transition: 'background 0.2s',
          fontSize: '14px'
        }}
      >
        Set API Key <ArrowRight size={16} />
      </button>
    </div>
  );
};

export default GroqKeyRequired;
